import React, { useState } from "react"

import { TableContainer } from "./styled"
import PlanItem from "./item"

export const MobileTable = ({
  plans,
  features,
  price,
  moreMobile,
  periodParams,
  link,
}) => {
  const [opened, setOpened] = useState([false, true, false])

  const handleOpened = planIndex => {
    setOpened(prev => prev.map((s, i) => (i === planIndex ? !s : false)))
  }


  return (
    <TableContainer className="mobile-table" style={{ marginTop: "0" }}>
      {plans.map((plan, i) => {
        return (
          <PlanItem
            key={`${plan}_${i}`}
            onClick={() => handleOpened(i)}
            opened={opened[i]}
            plan={plan}
            planFeatures={features[0]}
            shouldOpenable
            priceStep={price}
            more={moreMobile}
            link={link}
            periods={periodParams}
          />
        )
      })}
    </TableContainer>
  )
}
